<!-- 轮播组件 -->
<template>
  <div class="footer">
    <div class="footer-wrapper">
      <!-- 分类标题 -->
      <div class="category" style="align-items: center;">
        <div class="logos">
          <img src="../assets/images/logo.png" alt="">
          <img src="../assets/images/bdyh.png" alt="">
        </div>
        <div class="category-title">关于我们</div>
        <div class="category-title">智慧法治</div>
        <div class="category-title" style="width: 72px;">新闻资讯</div>
      </div>
      <!-- 分类内容 -->
      <div class="category" style="align-items: start;">
        <div class="category-panel">
          <div class="qrcode">
            <div class="qrcode-img">
              <img src="../assets/images/qrcode.png" alt="">
            </div>
            <div class="qrcode-label">
              在线客服
            </div>
          </div>
          
          <div class="info">
            <div class="info-item">
              <i class="icon-phone"></i>
              <span>400-810-8266</span>
            </div>
            <div class="info-item">
              <i class="icon-email"></i>
              <a style="color:#fff" href="mailto:info@chinalawinfo.com">info@chinalawinfo.com</a>
            </div>
          </div>
        </div>
        <div class="category-content">
          <div class="category-list">
            <a href="https://home.pkulaw.com/about?name=公司介绍" target="_blank" class="category-item">公司介绍</a>
            <a href="https://home.pkulaw.com/about?name=党建工会" target="_blank" class="category-item">党建工会</a>
          </div>
          <div class="category-list">
            <a href="https://home.pkulaw.com/about?name=资质荣誉" target="_blank" class="category-item">资质荣誉</a>
            <a href="https://home.pkulaw.com/about?name=大事迹" target="_blank" class="category-item" >大事迹</a>
            <a href="https://home.pkulaw.com/about?name=社会责任" target="_blank" class="category-item">社会责任</a>
          </div>
          <!-- <div class="category-list">
            <a href="javascript:void(0)" class="category-item">资质荣誉</a>
          </div> -->
        </div>
        <div class="category-content">
          <div class="category-list">
            <a href="https://home.pkulaw.com/serve?name=内容产品" target="_blank" class="category-item">内容产品</a>
            <a href="https://home.pkulaw.com/image?name=企业法治" target="_blank" class="category-item">企业法治</a>
          </div>
          <div class="category-list">
            <a href="https://home.pkulaw.com/serve?name=智慧立法" target="_blank" class="category-item">智慧立法</a>
            <a href="https://home.pkulaw.com/serve?name=智慧执法" target="_blank" class="category-item">智慧执法</a>
          </div>
          <div class="category-list">
            <a href="https://home.pkulaw.com/serve?name=智慧法院" target="_blank" class="category-item">智慧法院</a>
            <a href="https://home.pkulaw.com/serve?name=智慧检务" target="_blank" class="category-item">智慧检务</a>
          </div>
          <div class="category-list">
            <a href="https://home.pkulaw.com/serve?name=智慧教研" target="_blank" class="category-item">智慧教研</a>
          </div>
        </div>
        <div class="category-content" style="width: 72px;">
          <div class="category-list">
            <a href="https://home.pkulaw.com/news?name=资讯头条" target="_blank" class="category-item">资讯头条</a>
          </div>
          <div class="category-list">
            <a href="https://home.pkulaw.com/news?name=公司动态" target="_blank" class="category-item" >公司动态</a>
          </div>
          <div class="category-list">
            <a href="https://home.pkulaw.com/news?name=媒体报道" target="_blank" class="category-item" >媒体报道</a>
          </div>
           <div class="category-list">
            <a href="https://home.pkulaw.com/news?name=加入我们" target="_blank" class="category-item" >加入我们</a>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        版权所有：北京北大英华科技有限公司 北京大学法制信息中心 京ICP证010230-25
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    components: {

    },
    data() {
      return {

      }
    },
    methods: {
      // 跳转到关于我们
      handleLinkToAbout(data) {
        if (this.$route.path == '/about') {
          this.$emit('returnRouterIndex', data)
        } else {
          this.$router.push({
            name: 'About',
            params: {
              label: data
            }
          })
        }
      },
      // 跳转到新闻资讯
      handleLinkToNews(data) {
        if (this.$route.path == '/news') {
          this.$emit('returnRouterIndex', data)
        } else {
          this.$router.push({
            name: 'News',
            params: {
              label: data
            }
          })
        }
      },
    }
  }
</script>

<style scoped>
  .footer {
    /* height: 455px; */
    background-color: #1F2127;
  }

  .footer-wrapper {
    overflow: hidden;
    margin: 0 auto;
    padding: 100px 0 0;
    width: 1200px;
  }

  .logos img {
    margin: 0 20px 0 0;
  }

  .info {
    margin: 0 0 0 40px;
  }

  .info-item {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .info-item span {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }

  .icon-phone {
    margin: 0 10px 0 0;
    width: 20px;
    height: 20px;
    background: url(../assets/images/icon_phone.png) no-repeat 0 1px;
  }

  .icon-email {
    margin: 0 10px 0 0;
    width: 20px;
    height: 20px;
    background: url(../assets/images/icon_email.png) no-repeat 0 3px;
  }

  .category {
    display: flex;
    /* align-items: center; */
    margin: 40px 0;
  }

  .category-title {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }

  .category-item {
    display: inline-block;
    margin: 0 40px 16px 0;
    width: 70px;
    text-decoration: none;
    font-size: 14px;
    color: #fff;
    opacity: 0.5;
  }

  .footer-copyright {
    padding: 30px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
  }

  .logos {
    width: 600px;
  }

  .category-title {
    width: 266px;
  }

  .category-panel {
    display: flex;
    align-items: start;
    width: 600px;
  }

  .qrcode-label {
    text-align: center;
    font-size: 14px;
    color: #fff;
    opacity: 0.5;
  }

  .category-content {
    width: 266px;
  }
</style>